import { createSlice } from "@reduxjs/toolkit";
import {
  addWorkspace,
  cloneSpace,
  deleteWorkspace,
  getAllWorkshopRequest,
  getAllWorkspaces,
  getMeetingRoomsList,
  getSpaceListByType,
  getWebsiteRequests,
  getWorkshopInvoice,
  getWorkshopRequestDetails,
  getWorkspaceDetails,
  updateWorkshopRequest,
  updateWorkshopRequestShare,
  updateWorkshopRequestStatus,
  updateWorkspace,
  updateWorkspaceStatus,
  getWorkspaceList,
  getWorkspaceBookingDetails,
  checkEntireBranch,
  getNewWorkshopRequestCount,
  updateNewWorkshopRequestCount,
  getEnableDisableSpaceStatus,
  updateEnableDisableSpaceStatus,
} from "store/actions/workspaceSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  workspaces: [],
  unavailable: [],
  drafts: [],
  archived: [],
  workspaceDetails: {},
  meetingRoomsList: [],
  rejectedRooms: [],
  workshopRequests: [],
  workshopInvoiceDetails: {},
  spaceLists: [],
  websiteRequests: [],
  workspaceList: [],
  workspaceBookingDetails: {},
  checkEntireBranchData: [],
  newWorkshopRequestCount: 0,
  spaceStatus: {},
  currentSpaceStatus: [],
  workspaceFilters: {
    keyword: "",
    dates: [],
    selectedFilters: {
      status: -1,
      orderBy: -1,
      organizationId: "",
      branches: [],
    },
  },
};

const branchSlice = createSlice({
  name: "Workspace",
  initialState,
  reducers: {
    resetRejectedRooms: (state, action) => {
      state.rejectedRooms = [];
    },
    updateWorkspaceFilterState: (state, action) => {
      state.workspaceFilters = {
        ...state.workspaceFilters,
        ...action.payload,
      };
    },
    resetWorkspaceFilterState: (state) => {
      state.workspaceFilters = initialState.workspaceFilters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllWorkspaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllWorkspaces.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          // Separate workspaces and drafts based on status
          const workspaces = [];
          const drafts = [];
          const unavailable = [];
          const archived = [];

          if (data?.length > 0) {
            data.forEach((item) => {
              if (item.status === 1) {
                workspaces.push(item);
              } else if (item.status === 3) {
                drafts.push(item);
              } else if (item.status === 4) {
                unavailable.push(item);
              } else if (item.status === 5) {
                archived.push(item);
              }
            });
          }

          // Update state
          state.workspaces = workspaces || [];
          state.drafts = drafts || [];
          state.unavailable = unavailable || [];
          state.archived = archived || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllWorkspaces.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getWorkspaceDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWorkspaceDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.workspaceDetails = data;
        }
      })
      .addCase(getWorkspaceDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(addWorkspace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addWorkspace.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addWorkspace.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateWorkspace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWorkspace.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateWorkspace.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateWorkspaceStatus.pending, (state) => {
        state.isLoading = true;
      })
      // .addCase(updateWorkspaceStatus.fulfilled, (state, action) => {
      //   const { success, data } = action.payload || {};
      //   const { id, status: updatedStatus } = action.meta.arg;
      //   state.isLoading = false;
      //   if (success) {
      //     if (updatedStatus === 1) {
      //       // Remove from drafts, unavailable, archived → append to workspaces
      //       state.drafts = state.drafts.filter((item) => item._id !== id);
      //       state.unavailable = state.unavailable.filter(
      //         (item) => item._id !== id
      //       );
      //       state.archived = state.archived.filter((item) => item._id !== id);
      //       state.workspaces.push(data);
      //     } else if (updatedStatus === 3) {
      //       // Remove from workspaces, unavailable, archived → append to drafts
      //       state.workspaces = state.workspaces.filter(
      //         (item) => item._id !== id
      //       );
      //       state.unavailable = state.unavailable.filter(
      //         (item) => item._id !== id
      //       );
      //       state.archived = state.archived.filter((item) => item._id !== id);
      //       state.drafts.push(data);
      //     } else if (updatedStatus === 4) {
      //       // Remove from workspaces, drafts, archived → append to unavailable
      //       state.workspaces = state.workspaces.filter(
      //         (item) => item._id !== id
      //       );
      //       state.drafts = state.drafts.filter((item) => item._id !== id);
      //       state.archived = state.archived.filter((item) => item._id !== id);
      //       state.unavailable.push(data);
      //     } else if (updatedStatus === 5) {
      //       // Remove from workspaces, drafts, unavailable → append to archived
      //       state.workspaces = state.workspaces.filter(
      //         (item) => item._id !== id
      //       );
      //       state.drafts = state.drafts.filter((item) => item._id !== id);
      //       state.unavailable = state.unavailable.filter(
      //         (item) => item._id !== id
      //       );
      //       state.archived.push(data);
      //     }
      //   }
      // })
      .addCase(updateWorkspaceStatus.fulfilled, (state, action) => {
        const { success } = action.payload || {};
        const { id, status: updatedStatus } = action.meta.arg;
        state.isLoading = false;

        if (success) {
          // 1. Find item in all lists
          let item =
            state.workspaces.find((i) => i._id === id) ||
            state.drafts.find((i) => i._id === id) ||
            state.unavailable.find((i) => i._id === id) ||
            state.archived.find((i) => i._id === id);

          if (!item) return; // if not found, do nothing

          // 2. Update status
          item = { ...item, status: updatedStatus };

          // 3. Remove from all lists
          state.workspaces = state.workspaces.filter((i) => i._id !== id);
          state.drafts = state.drafts.filter((i) => i._id !== id);
          state.unavailable = state.unavailable.filter((i) => i._id !== id);
          state.archived = state.archived.filter((i) => i._id !== id);

          // 4. Push into correct list
          if (updatedStatus === 1) {
            state.workspaces.push(item);
          } else if (updatedStatus === 3) {
            state.drafts.push(item);
          } else if (updatedStatus === 4) {
            state.unavailable.push(item);
          } else if (updatedStatus === 5) {
            state.archived.push(item);
          }
        }
      })
      .addCase(updateWorkspaceStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteWorkspace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteWorkspace.fulfilled, (state, action) => {
        const { success } = action.payload;
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.workspaces = state.workspaces.filter((item) => item._id !== id);
          state.drafts = state.drafts.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteWorkspace.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(cloneSpace.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(cloneSpace.fulfilled, (state, action) => {
        const { success, data } = action.payload;
        const { id } = action.meta.arg;

        state.isLoading = false;
        if (success) {
          // const { status } = data;
          // if (status === 1) {
          //   state.workspaces.push(data);
          // } else if (status === 3) {
          //   state.drafts.push(data);
          // }
          // 1. Find the original item in workspaces or drafts by meta.arg.id
          let originalItem =
            state.workspaces.find((i) => i._id === id) ||
            state.drafts.find((i) => i._id === id);

          if (!originalItem) return; // do nothing if not found

          // 2. Create cloned item using originalItem but with new _id
          const clonedItem = {
            ...originalItem,
            _id: data._id,
          };

          // 3. Push into correct list based on status
          if (data.status === 1) {
            state.workspaces.push(clonedItem);
          } else if (data.status === 3) {
            state.drafts.push(clonedItem);
          }
        }
      })
      .addCase(cloneSpace.rejected, (state, action) => {
        state.isLoading = false;
      });

    // GET MEETING ROOMS TYPE
    builder
      .addCase(getMeetingRoomsList.pending, (state) => {
        state.meetingRoomsList = [];
        state.rejectedRooms = [];
      })
      .addCase(getMeetingRoomsList.fulfilled, (state, action) => {
        const { success, data } = action.payload;
        if (success) {
          const { availableRooms, rejectedRooms } = data || {};
          state.meetingRoomsList = availableRooms || [];
          state.rejectedRooms = rejectedRooms || [];
        }
      })
      .addCase(getMeetingRoomsList.rejected, (state, action) => {});

    // GET WORKSPACE LISTS
    builder
      .addCase(getWorkspaceList.pending, (state) => {
        state.workspaceList = [];
      })
      .addCase(getWorkspaceList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.workspaceList = data || [];
        }
      })
      .addCase(getWorkspaceList.rejected, (state, action) => {});

    // GET WORKSPACE BOOKING DETAILS
    builder
      .addCase(getWorkspaceBookingDetails.pending, (state) => {
        state.workspaceBookingDetails = {};
      })
      .addCase(getWorkspaceBookingDetails.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.workspaceBookingDetails = data || {};
        }
      })
      .addCase(getWorkspaceBookingDetails.rejected, (state, action) => {});

    // GET WORKSPACE BOOKING DETAILS
    builder
      .addCase(checkEntireBranch.pending, (state) => {
        state.checkEntireBranchData = [];
      })
      .addCase(checkEntireBranch.fulfilled, (state, action) => {
        const { success, data } = action.payload;
        if (success) {
          state.checkEntireBranchData = data || [];
        }
      })
      .addCase(checkEntireBranch.rejected, (state, action) => {});

    builder
      .addCase(getAllWorkshopRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllWorkshopRequest.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};

          state.workshopRequests = data || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllWorkshopRequest.rejected, (state, action) => {
        state.loading = false;
      });

    // STATUS UPDATE WORKSHOP REQUEST
    builder
      .addCase(updateWorkshopRequestStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWorkshopRequestStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        console.log(data);
        if (success) {
          state.workshopRequests = state?.workshopRequests?.map((item) =>
            item._id === data._id ? data : item
          );
        }
      })
      .addCase(updateWorkshopRequestStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getWorkshopRequestDetails.pending, (state) => {
        state.loading = true;
        state.workspaceDetails = {};
      })
      .addCase(getWorkshopRequestDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.workspaceDetails = data;
        }
      })
      .addCase(getWorkshopRequestDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateWorkshopRequest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWorkshopRequest.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateWorkshopRequest.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getWorkshopInvoice.pending, (state) => {
        state.isLoading = true;
        state.workshopInvoiceDetails = {};
      })
      .addCase(getWorkshopInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.workshopInvoiceDetails = data;
        }
      })
      .addCase(getWorkshopInvoice.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getSpaceListByType.pending, (state) => {})
      .addCase(getSpaceListByType.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.spaceLists = data;
        }
      })
      .addCase(getSpaceListByType.rejected, (state, action) => {});

    builder
      .addCase(getWebsiteRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWebsiteRequests.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};

          state.websiteRequests = data || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getWebsiteRequests.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateWorkshopRequestShare.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWorkshopRequestShare.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateWorkshopRequestShare.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getNewWorkshopRequestCount.pending, (state) => {
        state.isLoading = true;
        state.newWorkshopRequestCount = 0;
      })
      .addCase(getNewWorkshopRequestCount.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, count } = action.payload || {};
        if (success) {
          state.newWorkshopRequestCount = count;
        }
      })
      .addCase(getNewWorkshopRequestCount.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateNewWorkshopRequestCount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNewWorkshopRequestCount.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateNewWorkshopRequestCount.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getEnableDisableSpaceStatus.pending, (state) => {
        state.isLoading = true;
        state.spaceStatus = {};
        state.currentSpaceStatus = [];
      })
      .addCase(getEnableDisableSpaceStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.spaceStatus = data || [];
          state.currentSpaceStatus = data || [];
        }
      })
      .addCase(getEnableDisableSpaceStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateEnableDisableSpaceStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateEnableDisableSpaceStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success && data?.id) {
          // Update the matching space in currentSpaceStatus
          state.currentSpaceStatus = state.currentSpaceStatus.map((space) =>
            space._id === data.id
              ? {
                  ...space,
                  isHide: data.isHide,
                  displayOrder: data.displayOrder,
                }
              : space
          );
        }
      })
      .addCase(updateEnableDisableSpaceStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default branchSlice.reducer;
export const { resetRejectedRooms ,updateWorkspaceFilterState , resetWorkspaceFilterState } = branchSlice.actions;
